import React, { useEffect } from "react"

const ImageOpt = ({
  imgData,
  imgAlt,
  imgLoad,
  imgFetchPriority,
  imgClass,
  width,
  height,
}) => {
  useEffect(() => {
    imgCdn()
  }, [])

  const imgCdn = (imgData, width, height) => {
    const img = `https://wsrv.nl/?url=${imgData}&w=${width}&h=${height}&fit=cover&output=webp&q=90&dpr=1.4`
    return img
  }

  return (
    <>
      <img
        className={imgClass}
        src={imgCdn(imgData, width, height)}
        width={width}
        height={height}
        fetchpriority={imgFetchPriority ? imgFetchPriority : "auto"}
        alt={imgAlt}
        loading={imgLoad || "lazy"}
      />
    </>
  )
}

export default ImageOpt
